<div class="ui menu toolbar" paddingY="0" paddingX='10' appPadding>
  <div style="position: relative;left:1rem;" class="item header" id="no-borderline">
    <img
      class="ui image logo"
      src="./../../../../assets/Images/logo (2).svg"
      style="width: 70%"
    />
    <div class="logo-name">
      <p>SMTP API Manangement System</p>
    </div>
  </div>
</div>
